import React, { useCallback } from 'react';
import classNames             from 'classnames';
import DV                     from 'ts-data-validator';
import { NavLink, useParams } from 'react-router-dom';
import { useTranslation }     from 'react-i18next';

import usePrevious from '../../../../common/hooks/usePrevious';

import needReset         from '../../../common/tools/need-reset';
import ContactUs         from '../../../components/buttons/ContactUs';
import Meta              from '../../../components/meta';
import Preloader         from '../../../components/containers/preloader';
import Marquiz           from '../../../components/Marquiz/Marquiz';
import { Countdown }     from '../../../new-components';
import { useCatalog }    from '../../../providers/catalog';
import { useCommon }     from '../../../providers/common';
import { usePromotions } from '../../../providers/promotions';

import renderStaticSection from '../../_common/utils/renderStaticSection';
import Notfound            from '../../notfound/components/Notfound';

const PromotionsDetail = () => {
  const { urlKey } = useParams();
  const { pages }  = useCommon();

  const {
          getCatalogItems,
          resetFilter,
        } = useCatalog();

  const {
          getPromotionsDetail,
          resetPromotionsDetail,
          article,
          detailLoaded,
          loading,
        } = usePromotions();

  const {
          createdAtIso,
          headImage,
          label,
          meta: {
                  title,
                  meta: {
                          canonical,
                          description,
                          keywords,
                        },
                },
          activeFrom,
          activeTo,
          contactButtonName,
          updatedAtIso,
        }     = article;
  const { t } = useTranslation();

  // headImage — resolved путь на CDN без расширения
  const metaImages = headImage ? [{ alt: label || '', src: `${headImage}.webp`, type: 'image/webp' }] : undefined;

  const prevUrl = usePrevious(urlKey);

  React.useEffect(() => {
    if (!detailLoaded) {
      void getPromotionsDetail(urlKey);
    }

    if (!isSSR()) {
      scrollTo({
        top:  0,
        left: 0,
      });
    }
    return () => {
      void resetPromotionsDetail();
    };
  }, []);

  React.useEffect(() => {
    if (prevUrl !== urlKey && !loading) {
      void getPromotionsDetail(urlKey)
        .then(() => {
          scrollTo({
            top:  0,
            left: 0,
          });
        });
    }
  }, [urlKey]);

  const renderPage = useCallback(() => {
    if (
      detailLoaded &&
      DV.isNull(article?.label) &&
      DV.isNull(article?.headImage)
    ) {
      return <Notfound />;
    }

    let content = {};

    try {
      content = JSON.parse(article?.content);
    } catch (e) {
      return <Notfound />;
    }

    if (!detailLoaded) {
      return null;
    }

    return (
      <main className={'promotionsDetail'}>
        <div className={'main'}>
          <div
            className={'article'}
            itemScope
            itemType={'http://schema.org/Article'}
          >
            <meta itemProp={'datePublished'} content={article?.createdAt} />
            <meta
              content={article?.headImage}
              itemProp={'image'}
              itemType={'http://schema.org/ImageObject'}
            />
            <section>
              <div className={'container'}>
                <h1 itemProp={'headline'}>{article?.label}</h1>
              </div>
              <div className={'promotion_date'}>
                <p className={'promotion_create_time'}>{article?.createdAt}</p>
                <Countdown
                  from={activeFrom}
                  to={activeTo}
                />
              </div>
            </section>
            <article itemProp={'articleBody'} className={'articleBody'}>
              {content?.SECTIONS && content.SECTIONS.map((section, s) =>
                renderStaticSection(section, s),
              )}
            </article>
            <div className={'buttons_container'}>
              <NavLink
                className={classNames('btn', 'fill')}
                to={article?.buttonLink}
                onClick={() => {
                  if (needReset(article?.buttonLink)) {
                    void resetFilter();
                    void getCatalogItems(article?.buttonLink);
                  }
                }}
              >
                {article?.buttonName}
              </NavLink>
              <ContactUs label={contactButtonName || t('btn_get_advice')} />
              <NavLink
                className={classNames('btn', 'primary')}
                to={`/${pages.find(page => page.template === 'where-buy').urlKey}`}
              >
                {t('btn_where_buy')}
              </NavLink>
            </div>
          </div>
        </div>
        <Marquiz />
      </main>
    );
  }, [detailLoaded, article, loading]);

  return (
    <>
      <div className={'page-content'}>
        <Meta
          article={{
            author:        t('steelline'),
            modifiedTime:  updatedAtIso,
            publishedTime: createdAtIso,
            section:       'Акции',
          }}
          canonical={canonical}
          description={description}
          images={metaImages}
          keywords={keywords}
          title={title}
          type={'article'}
        />
        {renderPage()}
      </div>
      {(
        !detailLoaded || loading) && <Preloader />}
    </>
  );
};

export default PromotionsDetail;